<div class="font-bold mb-3" i18n>You answered "Yes" to map USIM and ISIM for the AKA parameters.</div>
<div class="font-bold mb-3" i18n>Please select the following Mapping Options:</div>
<div class="ml-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.mapUSIMandISIMforAKAconfiguration"
          inputId="networkAuthentication.mapUSIMandISIMforAKAconfiguration#1"
          value="1"
          [(ngModel)]="profileValues.networkAuthentication.mapUSIMandISIMforAKAconfiguration"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 label-clickable" for="networkAuthentication.mapUSIMandISIMforAKAconfiguration#1" i18n>
          Do not share SQN parameters and/or values
        </label>
      </td>
    </tr>
    <tr>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.mapUSIMandISIMforAKAconfiguration"
          inputId="networkAuthentication.mapUSIMandISIMforAKAconfiguration#2"
          value="2"
          [(ngModel)]="profileValues.networkAuthentication.mapUSIMandISIMforAKAconfiguration"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 label-clickable" for="networkAuthentication.mapUSIMandISIMforAKAconfiguration#2" i18n>
          Share sqnInit, sqnOptions, sqnDelta, sqnAgeLimit
        </label>
      </td>
    </tr>
    <tr>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.mapUSIMandISIMforAKAconfiguration"
          inputId="networkAuthentication.mapUSIMandISIMforAKAconfiguration#3"
          value="3"
          [(ngModel)]="profileValues.networkAuthentication.mapUSIMandISIMforAKAconfiguration"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 label-clickable" for="networkAuthentication.mapUSIMandISIMforAKAconfiguration#3" i18n>
          Share sqnOptions, sqnDelta, sqnAgeLimit
        </label>
      </td>
    </tr>
    <tr>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.mapUSIMandISIMforAKAconfiguration"
          inputId="networkAuthentication.mapUSIMandISIMforAKAconfiguration#4"
          value="4"
          [(ngModel)]="profileValues.networkAuthentication.mapUSIMandISIMforAKAconfiguration"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 label-clickable" for="networkAuthentication.mapUSIMandISIMforAKAconfiguration#4" i18n>
          Share sqnOptions, sqnDelta, sqnAgeLimit and SQN array
        </label>
      </td>
    </tr>
  </table>
</div>
